/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/order */
/* eslint-disable no-else-return */
/* eslint-disable import/no-duplicates */
import { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FieldArray, Form, Formik } from "formik";
import { MdOutlineDelete } from "react-icons/md";
import {
  IoIosArrowDown,
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
} from "react-icons/io";
import { FiPlus, FiTrash, FiX } from "react-icons/fi";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import * as Yup from "yup";
import { AiOutlinePlus } from "react-icons/ai";
import { api } from "../../../services/api";

import { PageTitle } from "../../../components/PageTitle";
import { AuthContext } from "../../../contexts/AuthContext";
import { FormButton } from "../../../components/FormButton";
import { UploadComponent } from "../components/UploadComponent";
import { SelectSingle } from "../../../components/SelectSingle";
import { SelectSearch } from "../../../components/SelectSearch";
import { MultiSelectDropdown } from "../../../components/MultiSelectDropdown";
import { DateHourPicker } from "../../../components/DateHourPicker";
import { AddButton } from "../../../components/AddButton";
import "react-datepicker/dist/react-datepicker.css";
import { ModalAddSector } from "../components/ModalAddSector";
import { ModalAddCostumer } from "../components/ModalAddCostumer";
import { ModalAddSignatureLocal } from "../components/ModalAddSignatureLocal";
import { BsCloudArrowUp } from "react-icons/bs";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Loading } from "../../../components/Loading";
import { Modal, ModalButton } from "../../../components/Modal";
import imageCompression from "browser-image-compression";
import moment from "moment";

registerLocale("ptBR", ptBR);

interface SelectSectors {
  id: string;
  name: string;
}

interface SelectCostumers {
  id: string;
  name: string;
}

interface SelectServices {
  [x: string]: any;
  id: string;
  name: string;
}

interface SelectEquipments {
  id: string;
  name: string;
  grade: string;
}

interface SelectResponsible {
  id: string;
  name: string;
}

interface SelectTechnician {
  id: string;
  name: string;
}

interface FormServices {
  id: string;
}

interface Equipment {
  name: string;
}

interface FormEquipments {
  equipment_id: string;
  name: string;
  grade: string;
  equipment: Equipment;
}

interface FormSectors {
  id: string;
  sector_id: string;
  equipments: FormEquipments[];
  observation: string;
  images: any;
  show: boolean;
}

interface FormTechVisitReport {
  costumer_id: string;
  user_id: string;
  begin: string;
  end: string;
  observation: string;
  pending: string;
  sectors: FormSectors[];
  services: FormServices[];
  responsible_id: string;
  technician_id: string;
  responsible_signature: string;
  technician_signature: string;
  status: string;
}

interface TechVisitReport {
  costumer_id: string;
  user_id: string;
  begin: string;
  end: string;
  observation: string;
  pending: string;
  sectors: FormSectors[];
  services: [];
  responsible_id: string;
  technician_id: string;
  responsible_signature: string;
  technician_signature: string;
  status: string;
}

interface Comments {
  id: string;
  user: {
    name: string;
    avatar_url?: string;
  };
  comment: string;
  created_at: string;
}

const schema = Yup.object().shape({
  begin: Yup.string().required("Selecione uma data e hora"),
  costumer_id: Yup.string().required("Selecione um cliente"),
  services: Yup.array().of(Yup.string()).required("Selecione os serviços"),
  pending: Yup.string().required("Selecione se existe pendência ou não"),
});

export function TechVisitReportEdit() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [report, setReport] = useState<TechVisitReport>();
  const [selectSectors, setSelectSectors] = useState<SelectSectors[]>([]);
  const [selectCostumers, setSelectCostumers] = useState<SelectCostumers[]>([]);
  const [selectServices, setSelectServices] = useState<SelectServices[]>([]);
  const [selectEquipments, setSelectEquipments] = useState<FormEquipments[]>(
    [],
  );
  const [selectResponsibles, setSelectResponsibles] = useState<
    SelectResponsible[]
  >([]);
  const [selectTechnicians, setSelectTechnicians] = useState<
    SelectTechnician[]
  >([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedServicesForm, setSelectedServicesForm] = useState([]);
  const [idCostumer, setIdCostumer] = useState("");
  const [modalAddSector, setModalAddSector] = useState(false);
  const [modalAddCostumer, setModalAddCostumer] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [comments, setComments] = useState<Comments[]>([]);
  const [comment, setComment] = useState("");

  const [loading, setLoading] = useState(false);

  // Estados para edição de assinaturas
  const [modalAddSignature, setModalAddSignature] = useState(false);
  const [signatureType, setSignatureType] = useState("");
  const [technicianSignatureData, setTechnicianSignatureData] = useState("");
  const [responsibleSignatureData, setResponsibleSignatureData] = useState("");
  const [confirmDelete, setConfirmDelete] = useState<{ show: boolean; type: string }>({ show: false, type: "" });

  // Estado para preview de imagem
  const [imagePreview, setImagePreview] = useState({ show: false, src: "", alt: "" });

  const navigate = useNavigate();

  useEffect(() => {
    api.get(`techVisitReport/${id}`).then(response => {
      const serviceOptions = response.data.services.map(
        ({ id: service_id, name }: SelectServices) => {
          return {
            value: service_id,
            label: name,
          };
        },
      );

      const servicesIds = response.data.services.map(
        ({ id: service_id }: SelectServices) => {
          return service_id;
        },
      );

      const { begin, end, costumer_id } = response.data;

      setSelectedServicesForm(servicesIds);
      setIdCostumer(costumer_id);
      setSelectedServices(serviceOptions);
      setEndDate(new Date(end));

      const beginUTC = begin;
      const beginLocal = new Date(beginUTC);
      // const beginLocalAjustada = new Date(
      //   beginLocal.getTime() + beginLocal.getTimezoneOffset() * 60000,
      // );
      setStartDate(beginLocal);

      const endUTC = end;
      const endLocal = new Date(endUTC);
      // const endLocalAjustada = new Date(
      //   endLocal.getTime() + endLocal.getTimezoneOffset() * 60000,
      // );
      setEndDate(endLocal);

      return setReport(response.data);
    });
  }, [refresh]);

  useEffect(() => {
    api.get(`techVisitReport/comment/${id}`).then(response => {
      return setComments(response.data);
    });
  }, [refresh]);

  useEffect(() => {
    api
      .get("/costumers", {
        params: {
          status: "A",
        },
      })
      .then(response => {
        return setSelectCostumers(response.data);
      });
  }, [modalAddCostumer]);

  useEffect(() => {
    api
      .get("/services", {
        params: {
          status: "A",
        },
      })
      .then(response => {
        const serviceOptions = response.data.map(
          ({ id: service_id, name }: SelectServices) => {
            return {
              value: service_id,
              label: name,
            };
          },
        );

        return setSelectServices(serviceOptions);
      });

    api
      .get("/equipments", {
        params: {
          status: "A",
        },
      })
      .then(response => {
        const equipmentForm = response.data.map(
          (equipment: SelectEquipments) => {
            return {
              equipment_id: equipment.id,
              name: equipment.name,
              grade: "",
            };
          },
        );

        return setSelectEquipments(equipmentForm);
      });

    api
      .get("/users", {
        params: { status: "A" },
      })
      .then(response => {
        return setSelectTechnicians(response.data);
      });
  }, []);

  useEffect(() => {
    api
      .get("/sectors", {
        params: {
          costumer_id: idCostumer,
          status: "A",
        },
      })
      .then(response => {
        return setSelectSectors(response.data.data || []);
      });

    api
      .get("/responsibles", {
        params: { costumer_id: idCostumer, status: "A" },
      })
      .then(response => {
        return setSelectResponsibles(response.data.data || []);
      });
  }, [idCostumer, modalAddSector]);

  // Função para abrir modal de assinatura
  function openSignatureModal(type: string) {
    setSignatureType(type);
    setModalAddSignature(true);
  }

  // Função para salvar assinatura localmente
  function handleSaveSignatureLocal(signatureData: string) {
    if (signatureType === "technician_signature") {
      setTechnicianSignatureData(signatureData);
    } else if (signatureType === "responsible_signature") {
      setResponsibleSignatureData(signatureData);
    }
    setModalAddSignature(false);
  }

  // Função para confirmar exclusão de assinatura
  function handleConfirmDelete() {
    if (confirmDelete.type === "technician") {
      setTechnicianSignatureData("");
    } else if (confirmDelete.type === "responsible") {
      setResponsibleSignatureData("");
    }
    setConfirmDelete({ show: false, type: "" });
  }

  // Função para converter base64 para Blob
  function dataURIToBlob(dataURI: string): Blob {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  // Função para fazer upload de assinatura usando o endpoint correto
  async function uploadSignature(signatureData: string, type: "technician" | "responsible"): Promise<boolean> {
    if (!signatureData || !signatureData.startsWith("data:image")) {
      return false;
    }
    try {
      const blob = dataURIToBlob(signatureData);
      const formData = new FormData();
      formData.append("signature_file", blob, "signature.png");

      const endpoint = type === "technician"
        ? `/techVisitReport/technician_signature/${id}`
        : `/techVisitReport/responsible_signature/${id}`;

      await api.patch(endpoint, formData);
      return true;
    } catch (error) {
      console.error("Erro ao fazer upload da assinatura:", error);
      return false;
    }
  }

  async function handleSubmit({
    costumer_id,
    begin,
    end,
    observation,
    pending,
    sectors,
    services,
    responsible_id,
    technician_id,
    status,
  }: FormTechVisitReport) {
    // Upload das novas assinaturas se foram editadas (usando endpoints dedicados)
    if (technicianSignatureData) {
      await uploadSignature(technicianSignatureData, "technician");
    }
    if (responsibleSignatureData) {
      await uploadSignature(responsibleSignatureData, "responsible");
    }

    // Atualizar responsável e técnico
    await api.patch(`/techVisitReport/responsibles/${id}`, {
      responsible_id,
      technician_id,
    });

    const servicesFormated = services.map(service => {
      return { service_id: service };
    });

    // const sectorsFormated = sectors.map(
    //   ({
    //     sector_id,
    //     equipments,
    //     images,
    //     observation: sector_observation,
    //   }: FormSectors) => {
    //     const equipmentsFormated = equipments.map(equipment => {
    //       return {
    //         equipment_id: Object.keys(equipment)[0],
    //         grade: Object.values(equipment)[0],
    //       };
    //     });

    //     return {
    //       sector_id,
    //       equipments: equipmentsFormated,
    //       images,
    //       observation: sector_observation,
    //     };
    //   },
    // );

    const { report_sector_ids } = await api
      .put(`/techVisitReport/${id}`, {
        costumer_id,
        user_id: user.id,
        begin,
        end,
        observation,
        pending,
        services: servicesFormated,
        sectors,
        status,
      })
      .then(response => {
        return response.data;
      });

    sectors.forEach(async ({ sector_id, images }) => {
      const { report_sector_id } = await report_sector_ids.find(
        element => element.sector_id === sector_id,
      );

      await images.forEach(file => {
        const data = new FormData();

        data.append("files", file);

        api.post(`/techVisitReport/sector_images/${report_sector_id}`, data);
      });
    });

    return navigate(`/tech-visit-reports`);
  }

  async function deleteImage({ id: image_id }) {
    setLoading(true);
    await api.delete(`/techVisitReport/sector_images/${image_id}`);

    setTimeout(() => {
      setRefresh(!refresh);
      return setLoading(false);
    }, 2000);
  }

  async function updateImage({ file, report_sector_id }) {
    setLoading(true);
    const data = new FormData();

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const fileCompressed: any = await imageCompression(file, options);

    data.append("files", fileCompressed);

    await api.post(`/techVisitReport/sector_images/${report_sector_id}`, data);

    setTimeout(() => {
      setRefresh(!refresh);
      return setLoading(false);
    }, 2000);
  }

  // Função para abrir preview de imagem
  const openImagePreview = useCallback((src: string, alt: string) => {
    setImagePreview({ show: true, src, alt });
  }, []);

  // Função para fechar preview de imagem
  const closeImagePreview = useCallback(() => {
    setImagePreview({ show: false, src: "", alt: "" });
  }, []);

  // Detectar tecla ESC para fechar preview de imagem
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && imagePreview.show) {
        closeImagePreview();
      }
    };

    if (imagePreview.show) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [imagePreview.show, closeImagePreview]);

  async function sendComment() {
    await api.post(`/techVisitReport/comment/${id}`, {
      comment,
      user_id: user.id,
    });

    setComment("");
    setRefresh(!refresh);
  }

  const initialValues: FormTechVisitReport = !report
    ? {
        begin: "",
        end: "",
        costumer_id: "",
        user_id: user.id,
        services: [],
        sectors: [],
        pending: "",
        observation:
          "Os demais setores e equipamentos estavam em bom estado de conservação e(ou) funcionamento.",
        responsible_id: "",
        responsible_signature: "",
        technician_id: "",
        technician_signature: "",
        status: "",
      }
    : {
        begin: report.begin,
        end: report.end,
        costumer_id: report.costumer_id,
        user_id: report.user_id,
        services: selectedServicesForm,
        sectors: report.sectors,
        pending: report.pending,
        observation: report.observation,
        responsible_id: report.responsible_id,
        responsible_signature: report.responsible_signature,
        technician_id: report.technician_id,
        technician_signature: report.technician_signature,
        status: report.status,
      };

  return (
    <>
      {loading && <Loading />}
      <div className="container mx-auto">
        <PageTitle
          title="Editar Relatório"
          backButton
          backPath="/tech-visit-reports"
        />
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={schema}
          onSubmit={values => {
            handleSubmit(values);
          }}
        >
          {({ errors, touched, values, setFieldValue, setFieldTouched }) => (
            <Form className="flex flex-col flex-wrap space-y-4">
              {/* Seção 1: Dados da Visita */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100">
                <div className="bg-gradient-to-r from-[#0085BD] to-[#006a96] px-6 py-4 rounded-t-2xl">
                  <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    Dados da Visita
                  </h3>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-semibold text-gray-700 mb-2 block">
                        Data e hora do início da visita
                      </label>
                      <DateHourPicker
                        selected={startDate}
                        onChange={date => {
                          setStartDate(date);
                          setFieldValue("begin", moment(date).format());
                        }}
                        timeInputLabel="Time:"
                        dateFormat="dd/MM/yyyy H:mm"
                        showTimeInput
                        error={errors.begin}
                      />
                    </div>

                    <div>
                      <label className="text-sm font-semibold text-gray-700 mb-2 block">
                        Data e hora do término da visita
                      </label>
                      <DateHourPicker
                        selected={endDate}
                        onChange={date => {
                          setEndDate(date);
                          setFieldValue("end", moment(date).format());
                        }}
                        timeInputLabel="Time:"
                        dateFormat="dd/MM/yyyy H:mm"
                        showTimeInput
                        error={errors.end}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <label className="text-sm font-semibold text-gray-700 mb-2 block">
                      Cliente
                    </label>
                    <div className="flex gap-2">
                      <SelectSearch
                        name="costumer_id"
                        placeholder="Digite o nome do cliente..."
                        value={idCostumer}
                        onChange={value => {
                          setFieldValue("costumer_id", value);
                          setFieldTouched("costumer_id", true);
                          setIdCostumer(value);
                        }}
                        error={errors.costumer_id}
                      />
                      <AddButton
                        onClick={() => setModalAddCostumer(true)}
                        tooltip="Adicionar novo cliente"
                        size="md"
                      />
                      {modalAddCostumer && (
                        <ModalAddCostumer
                          setModalAddCostumer={setModalAddCostumer}
                        />
                      )}
                    </div>
                  </div>

                  <div className="mt-4">
                    <label className="text-sm font-semibold text-gray-700 mb-2 block">
                      Serviços
                    </label>
                    <MultiSelectDropdown
                      name="services"
                      options={selectServices.map(s => ({
                        value: s.value || s.id,
                        label: s.label || s.name,
                      }))}
                      value={selectedServicesForm}
                      placeholder="Selecione os serviços..."
                      onChange={selectedValues => {
                        setSelectedServicesForm(selectedValues);
                        const selectedOptions = selectServices.filter(opt =>
                          selectedValues.includes(opt.value || opt.id),
                        );
                        setSelectedServices(selectedOptions);
                      }}
                      error={
                        typeof errors.services === "string"
                          ? errors.services
                          : undefined
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Seção 2: Setores */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="bg-gradient-to-r from-[#0085BD] to-[#006a96] px-6 py-4">
                  <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                    Setores Visitados
                  </h3>
                </div>
                <div className="p-6">
                <FieldArray
                  name="sectors"
                  render={arraySectors => (
                    <div className="space-y-4">
                      {values.sectors && values.sectors.length > 0 ? (
                        values.sectors.map(
                          (
                            { id: sectorItemId, show, images }: FormSectors,
                            indexSector,
                          ) => (
                            <div
                              className="relative rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow mt-6"
                              key={sectorItemId || `sector-new-${indexSector}`}
                            >
                              {/* Botão Minimizar/Maximizar - Centro Superior */}
                              <button
                                type="button"
                                className="absolute left-1/2 -translate-x-1/2 -top-4 z-10 w-8 h-8 flex items-center justify-center bg-[#0085BD] hover:bg-[#006a96] rounded-full shadow-lg transition-all hover:scale-110"
                                onClick={() =>
                                  setFieldValue(
                                    `sectors[${indexSector}].show`,
                                    !show,
                                  )
                                }
                                title={show ? "Recolher" : "Expandir"}
                              >
                                <IoIosArrowDown
                                  size={18}
                                  className={`text-white transition-transform duration-300 ${show ? "rotate-180" : "rotate-0"}`}
                                />
                              </button>

                              {/* Botão Excluir - Canto Superior Esquerdo */}
                              <button
                                type="button"
                                onClick={() =>
                                  arraySectors.remove(indexSector)
                                }
                                className="absolute -top-3 -left-3 z-10 w-8 h-8 flex items-center justify-center bg-red-500 hover:bg-red-600 rounded-full shadow-lg transition-all hover:scale-110"
                                title="Remover setor"
                              >
                                <FiTrash size={14} className="text-white" />
                              </button>

                              {/* Header do Setor */}
                              <div className="bg-gradient-to-r from-[#0085BD] to-[#00a8e8] p-4 pt-6 rounded-t-xl">
                                <div>
                                  <label className="text-xs font-medium text-white/80 uppercase tracking-wide mb-1 block">
                                    Setor
                                  </label>
                                  <div className="flex gap-2">
                                      <Field
                                        as="select"
                                        name={`sectors[${indexSector}].sector_id`}
                                        className="h-11 px-4 w-full rounded-lg text-gray-700 bg-white/95 backdrop-blur border-0 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all text-sm font-medium"
                                      >
                                        <option value="" disabled>
                                          Selecione um setor
                                        </option>
                                        {selectSectors &&
                                          selectSectors.map(
                                            ({
                                              id: sectorId,
                                              name,
                                            }: SelectSectors) => (
                                              <option
                                                key={sectorId}
                                                value={sectorId}
                                              >
                                                {name}
                                              </option>
                                            ),
                                          )}
                                      </Field>
                                      <AddButton
                                        onClick={() => setModalAddSector(true)}
                                        tooltip="Cadastrar novo setor"
                                        size="md"
                                      />
                                      {modalAddSector && (
                                        <ModalAddSector
                                          setModalAddSector={setModalAddSector}
                                        />
                                      )}
                                    </div>
                                </div>
                              </div>

                              {/* Conteúdo Expansível */}
                              <div
                                className={`transition-all duration-300 ease-in-out ${
                                  show
                                    ? "max-h-[3000px] opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <div className="p-4 bg-gray-50/50">
                                  {/* Tabela de Equipamentos - Mobile Friendly */}
                                  <div className="mb-4">
                                    <div className="flex items-center gap-2 mb-3">
                                      <svg className="w-4 h-4 text-[#0085BD]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                                      </svg>
                                      <span className="text-sm font-semibold text-gray-700">Avaliação dos Equipamentos</span>
                                    </div>

                                    {/* Legenda - Mobile */}
                                    <div className="sm:hidden flex items-center justify-end gap-3 mb-2 px-2 py-1.5 bg-gray-100 rounded-lg text-[10px]">
                                      <span className="text-gray-500 font-medium">Legenda:</span>
                                      <span className="flex items-center gap-1">
                                        <span className="w-4 h-4 rounded bg-green-500 text-white flex items-center justify-center font-bold">O</span>
                                        <span className="text-gray-600">Ótimo</span>
                                      </span>
                                      <span className="flex items-center gap-1">
                                        <span className="w-4 h-4 rounded bg-yellow-500 text-white flex items-center justify-center font-bold">B</span>
                                        <span className="text-gray-600">Bom</span>
                                      </span>
                                      <span className="flex items-center gap-1">
                                        <span className="w-4 h-4 rounded bg-red-500 text-white flex items-center justify-center font-bold">R</span>
                                        <span className="text-gray-600">Revisado</span>
                                      </span>
                                      <span className="flex items-center gap-1">
                                        <span className="w-4 h-4 rounded bg-blue-500 text-white flex items-center justify-center font-bold">S</span>
                                        <span className="text-gray-600">Substituído</span>
                                      </span>
                                    </div>

                                    {/* Header da Tabela - Desktop */}
                                    <div className="hidden sm:grid grid-cols-[1fr,repeat(5,48px)] gap-2 mb-2 px-3 py-2 bg-[#0085BD]/10 rounded-lg">
                                      <span className="text-xs font-bold text-[#0085BD] uppercase">Equipamento</span>
                                      <span className="text-xs font-bold text-green-600 text-center" title="Ótimo">O</span>
                                      <span className="text-xs font-bold text-yellow-600 text-center" title="Bom">B</span>
                                      <span className="text-xs font-bold text-red-600 text-center" title="Revisado">R</span>
                                      <span className="text-xs font-bold text-blue-600 text-center" title="Substituído">S</span>
                                      <span className="text-xs font-bold text-gray-400 text-center">⌫</span>
                                    </div>

                                    {/* Lista de Equipamentos */}
                                    <div className="space-y-1">
                                      {values.sectors[indexSector].equipments.map(
                                        (
                                          { equipment_id, equipment },
                                          indexEquipment,
                                        ) => (
                                          <div
                                            key={`equip-${indexSector}-${indexEquipment}`}
                                            className={`rounded-lg border border-gray-200 p-2 sm:p-3 hover:border-[#0085BD]/30 transition-colors ${
                                              indexEquipment % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                                            }`}
                                          >
                                            {/* Mobile Layout - Compacto em linha */}
                                            <div className="sm:hidden flex items-center justify-between gap-2">
                                              <span className="text-xs font-medium text-gray-700 flex-1 truncate">{equipment.name}</span>
                                              <div className="flex items-center gap-1">
                                                <label className={`flex items-center justify-center w-8 h-8 rounded-md cursor-pointer transition-all ${
                                                  values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'O'
                                                    ? 'bg-green-500 text-white shadow-sm'
                                                    : 'bg-gray-100 text-gray-400 active:bg-green-100'
                                                }`}>
                                                  <Field
                                                    type="radio"
                                                    value="O"
                                                    name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                    className="sr-only"
                                                  />
                                                  <span className="text-xs font-bold">O</span>
                                                </label>
                                                <label className={`flex items-center justify-center w-8 h-8 rounded-md cursor-pointer transition-all ${
                                                  values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'B'
                                                    ? 'bg-yellow-500 text-white shadow-sm'
                                                    : 'bg-gray-100 text-gray-400 active:bg-yellow-100'
                                                }`}>
                                                  <Field
                                                    type="radio"
                                                    value="B"
                                                    name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                    className="sr-only"
                                                  />
                                                  <span className="text-xs font-bold">B</span>
                                                </label>
                                                <label className={`flex items-center justify-center w-8 h-8 rounded-md cursor-pointer transition-all ${
                                                  values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'R'
                                                    ? 'bg-red-500 text-white shadow-sm'
                                                    : 'bg-gray-100 text-gray-400 active:bg-red-100'
                                                }`}>
                                                  <Field
                                                    type="radio"
                                                    value="R"
                                                    name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                    className="sr-only"
                                                  />
                                                  <span className="text-xs font-bold">R</span>
                                                </label>
                                                <label className={`flex items-center justify-center w-8 h-8 rounded-md cursor-pointer transition-all ${
                                                  values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'S'
                                                    ? 'bg-blue-500 text-white shadow-sm'
                                                    : 'bg-gray-100 text-gray-400 active:bg-blue-100'
                                                }`}>
                                                  <Field
                                                    type="radio"
                                                    value="S"
                                                    name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                    className="sr-only"
                                                  />
                                                  <span className="text-xs font-bold">S</span>
                                                </label>
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    setFieldValue(
                                                      `sectors[${indexSector}].equipments[${indexEquipment}].grade`,
                                                      "",
                                                    );
                                                  }}
                                                  className="w-6 h-8 flex items-center justify-center text-gray-300 active:text-red-500 transition-colors"
                                                  title="Limpar"
                                                >
                                                  <FiX size={14} />
                                                </button>
                                              </div>
                                            </div>

                                            {/* Desktop Layout */}
                                            <div className="hidden sm:grid grid-cols-[1fr,repeat(5,48px)] gap-2 items-center">
                                              <span className="text-sm font-medium text-gray-700">{equipment.name}</span>
                                              <label className={`flex items-center justify-center w-10 h-10 mx-auto rounded-lg cursor-pointer transition-all ${
                                                values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'O'
                                                  ? 'bg-green-500 text-white shadow-md'
                                                  : 'bg-gray-100 text-gray-400 hover:bg-green-100 hover:text-green-600'
                                              }`}>
                                                <Field
                                                  type="radio"
                                                  value="O"
                                                  name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                  className="sr-only"
                                                />
                                                <span className="text-sm font-bold">O</span>
                                              </label>
                                              <label className={`flex items-center justify-center w-10 h-10 mx-auto rounded-lg cursor-pointer transition-all ${
                                                values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'B'
                                                  ? 'bg-yellow-500 text-white shadow-md'
                                                  : 'bg-gray-100 text-gray-400 hover:bg-yellow-100 hover:text-yellow-600'
                                              }`}>
                                                <Field
                                                  type="radio"
                                                  value="B"
                                                  name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                  className="sr-only"
                                                />
                                                <span className="text-sm font-bold">B</span>
                                              </label>
                                              <label className={`flex items-center justify-center w-10 h-10 mx-auto rounded-lg cursor-pointer transition-all ${
                                                values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'R'
                                                  ? 'bg-red-500 text-white shadow-md'
                                                  : 'bg-gray-100 text-gray-400 hover:bg-red-100 hover:text-red-600'
                                              }`}>
                                                <Field
                                                  type="radio"
                                                  value="R"
                                                  name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                  className="sr-only"
                                                />
                                                <span className="text-sm font-bold">R</span>
                                              </label>
                                              <label className={`flex items-center justify-center w-10 h-10 mx-auto rounded-lg cursor-pointer transition-all ${
                                                values.sectors[indexSector]?.equipments?.[indexEquipment]?.grade === 'S'
                                                  ? 'bg-blue-500 text-white shadow-md'
                                                  : 'bg-gray-100 text-gray-400 hover:bg-blue-100 hover:text-blue-600'
                                              }`}>
                                                <Field
                                                  type="radio"
                                                  value="S"
                                                  name={`sectors[${indexSector}].equipments[${indexEquipment}].grade`}
                                                  className="sr-only"
                                                />
                                                <span className="text-sm font-bold">S</span>
                                              </label>
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  setFieldValue(
                                                    `sectors[${indexSector}].equipments[${indexEquipment}].grade`,
                                                    "",
                                                  );
                                                }}
                                                className="flex items-center justify-center w-10 h-10 mx-auto rounded-lg text-gray-400 hover:bg-red-100 hover:text-red-500 transition-colors"
                                                title="Limpar seleção"
                                              >
                                                <MdOutlineDelete size={16} />
                                              </button>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>

                                  {/* Observações do Setor */}
                                  <div className="mb-4">
                                    <div className="flex items-center gap-2 mb-2">
                                      <svg className="w-4 h-4 text-[#0085BD]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                      </svg>
                                      <span className="text-sm font-semibold text-gray-700">Observações do Setor</span>
                                    </div>
                                    <Field
                                      as="textarea"
                                      placeholder="Adicione observações específicas deste setor..."
                                      name={`sectors[${indexSector}].observation`}
                                      className="w-full h-24 p-3 rounded-lg text-gray-700 bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-2 focus:ring-[#0085BD]/20 focus:outline-none resize-none text-sm transition-all"
                                    />
                                  </div>

                                  {/* Imagens do Setor */}
                                  <div>
                                    <div className="flex items-center gap-2 mb-2">
                                      <svg className="w-4 h-4 text-[#0085BD]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                      </svg>
                                      <span className="text-sm font-semibold text-gray-700">Fotos do Setor</span>
                                    </div>
                                    <div className="flex flex-wrap gap-2">
                                      <FieldArray
                                        name={`sectors[${indexSector}].images`}
                                        render={arrayImages => (
                                          <>
                                            {images.map((file, indexImage) => {
                                              return (
                                                <div className="relative group" key={`img-${indexSector}-${indexImage}`}>
                                                  {file.file_name !==
                                                  undefined ? (
                                                    <button
                                                      type="button"
                                                      className="w-16 h-16 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-[#0085BD] transition-colors focus:outline-none focus:ring-2 focus:ring-[#0085BD]"
                                                      onClick={() => openImagePreview(
                                                        `https://app-luvilimp.s3.amazonaws.com/techVisitReportSectorImages/${file.file_name}`,
                                                        `Imagem do setor ${indexSector + 1}`
                                                      )}
                                                      title="Clique para ampliar"
                                                      aria-label={`Ampliar imagem do setor ${indexSector + 1}`}
                                                    >
                                                      <img
                                                        className="w-full h-full object-cover"
                                                        src={`https://app-luvilimp.s3.amazonaws.com/techVisitReportSectorImages/${file.file_name}`}
                                                        alt={`Imagem do setor ${indexSector + 1}`}
                                                      />
                                                    </button>
                                                  ) : (
                                                    <label
                                                      htmlFor={`sectors[${indexSector}].image[${indexImage}]`}
                                                      className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 hover:border-[#0085BD] hover:bg-[#0085BD]/5 cursor-pointer transition-all"
                                                    >
                                                      <BsCloudArrowUp className="text-[#0085BD] text-xl" />
                                                      <input
                                                        type="file"
                                                        id={`sectors[${indexSector}].image[${indexImage}]`}
                                                        className="hidden"
                                                        onChange={e => {
                                                          updateImage({
                                                            report_sector_id:
                                                              values.sectors[
                                                                indexSector
                                                              ].id,
                                                            file: e.target
                                                              .files[0],
                                                          });
                                                        }}
                                                      />
                                                    </label>
                                                  )}
                                                  <button
                                                    type="button"
                                                    className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center shadow-md"
                                                    onClick={() => {
                                                      if (id === undefined) {
                                                        arrayImages.remove(
                                                          indexImage,
                                                        );
                                                      } else {
                                                        deleteImage({
                                                          id: file.id,
                                                        });
                                                      }
                                                    }}
                                                    title="Remover imagem"
                                                  >
                                                    <FiTrash size={10} className="text-white" />
                                                  </button>
                                                </div>
                                              );
                                            })}
                                            <button
                                              type="button"
                                              onClick={() => {
                                                arrayImages.push({});
                                              }}
                                              className="w-16 h-16 flex items-center justify-center bg-[#0085BD]/10 hover:bg-[#0085BD]/20 rounded-lg border-2 border-dashed border-[#0085BD]/50 hover:border-[#0085BD] transition-all"
                                              title="Adicionar imagem"
                                            >
                                              <FiPlus size={20} className="text-[#0085BD]" />
                                            </button>
                                          </>
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <div className="text-center py-8 text-gray-500">
                          <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                          <p className="text-sm">Nenhum setor adicionado</p>
                          <p className="text-xs text-gray-400">Clique no botão abaixo para adicionar um setor</p>
                        </div>
                      )}
                      <div className="mt-4 flex justify-center">
                        <button
                          type="button"
                          onClick={() =>
                            arraySectors.push({
                              sector_id: "",
                              equipments: selectEquipments,
                              observation: "",
                              show: true,
                            })
                          }
                          className="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-[#0085BD] to-[#006a96] text-white rounded-xl hover:from-[#006a96] hover:to-[#005580] transition-all duration-200 shadow-md hover:shadow-lg group"
                        >
                          <FiPlus
                            size={20}
                            className="transition-transform duration-200 group-hover:rotate-90"
                          />
                          <span className="font-medium">
                            Adicionar Setor
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                />
                </div>
              </div>

              {/* Seção 3: Observações e Pendências */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="bg-gradient-to-r from-[#0085BD] to-[#006a96] px-6 py-4">
                  <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    Observações e Pendências
                  </h3>
                </div>
                <div className="p-6 space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-semibold text-gray-700 mb-2 block">
                        Ficou alguma pendência?
                      </label>
                      <SelectSingle
                        name="pending"
                        defaultValue=""
                        onChange={e => setFieldValue("pending", e.target.value)}
                      >
                        <option value="" disabled>
                          Sim ou Não
                        </option>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </SelectSingle>
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-semibold text-gray-700 mb-2 block">
                      Notas
                    </label>
                    <Field
                      as="textarea"
                      placeholder="Observações gerais sobre a visita..."
                      name="observation"
                      className="h-[120px] p-4 w-full rounded-xl text-gray-700 bg-gray-50 focus:bg-white focus:outline-none resize-none scrollbar-thumb-[#0085BD] scrollbar-track-transparent scrollbar-thin focus:ring-2 focus:ring-[#0085BD]/20 border border-gray-200 transition-all duration-200"
                    />
                  </div>
                </div>
              </div>

              {/* Seção 4: Responsáveis e Assinaturas */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="bg-gradient-to-r from-[#0085BD] to-[#006a96] px-6 py-4">
                  <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                    Responsáveis e Assinaturas
                  </h3>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Responsável Técnico */}
                    <div className="p-4 bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl border border-gray-100 space-y-3">
                      <label className="text-sm font-semibold text-gray-700 block">
                        Responsável Técnico
                      </label>
                      <Field
                        as="select"
                        name="technician_id"
                        className="h-[52px] px-4 w-full rounded-xl text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-[#0085BD]/20 border border-gray-200 transition-all duration-200"
                      >
                        <option value="" defaultChecked disabled>
                          Selecione o responsável
                        </option>
                        {selectTechnicians &&
                          selectTechnicians.map(({ id: technician_id, name }) => (
                            <option key={technician_id} value={technician_id}>
                              {name}
                            </option>
                          ))}
                      </Field>

                      {/* Assinatura do Técnico */}
                      <div className="mt-3">
                        <p className="text-xs font-medium text-gray-500 mb-2">
                          Assinatura do Técnico
                        </p>
                        <div className="space-y-3">
                          <div className="relative">
                            <button
                              type="button"
                              className="w-full h-[100px] border-2 border-dashed border-[#0085BD]/30 rounded-xl flex items-center justify-center bg-white cursor-pointer hover:bg-blue-50 transition-all duration-200 relative group"
                              onClick={() => openSignatureModal("technician_signature")}
                            >
                              {technicianSignatureData ? (
                                <>
                                  <img
                                    src={technicianSignatureData}
                                    alt="Nova Assinatura do Técnico"
                                    className="max-h-full max-w-full object-contain"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200 rounded-xl flex items-center justify-center">
                                    <span className="bg-[#0085BD] text-white px-3 py-1 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                      Clique para editar
                                    </span>
                                  </div>
                                </>
                              ) : report && report.technician_signature ? (
                                <>
                                  <img
                                    className="max-h-full max-w-full object-contain"
                                    src={`https://app-luvilimp.s3.amazonaws.com/techVisitReportSignatureImages/${report.technician_signature}`}
                                    alt="Assinatura do Técnico"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200 rounded-xl flex items-center justify-center">
                                    <span className="bg-[#0085BD] text-white px-3 py-1 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                      Clique para editar
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="text-center text-[#7FA5B2]">
                                  <svg className="mx-auto h-6 w-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  <p className="text-xs">Clique para assinar</p>
                                </div>
                              )}
                            </button>
                          </div>
                          {(technicianSignatureData || (report && report.technician_signature)) && (
                            <div className="flex gap-2">
                              <button
                                type="button"
                                onClick={() => openSignatureModal("technician_signature")}
                                className="flex-1 px-2 py-2 bg-[#0085BD] text-white rounded-lg hover:bg-[#006a99] transition-all duration-200 text-xs font-semibold flex items-center justify-center gap-1"
                              >
                                <FiEdit2 size={14} /> Editar
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Responsável Cliente */}
                    <div className="p-4 bg-gradient-to-br from-gray-50 to-green-50 rounded-xl border border-gray-100 space-y-3">
                      <label className="text-sm font-semibold text-gray-700 block">
                        Responsável Cliente
                      </label>
                      <Field
                        as="select"
                        name="responsible_id"
                        className="h-[52px] px-4 w-full rounded-xl text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-[#0085BD]/20 border border-gray-200 transition-all duration-200"
                      >
                        <option value="" defaultChecked disabled>
                          Selecione o responsável
                        </option>
                        {selectResponsibles &&
                          selectResponsibles.map(
                            ({ id: responsible_id, name: responsible_name }) => (
                              <option key={responsible_id} value={responsible_id}>
                                {responsible_name}
                              </option>
                            ),
                          )}
                      </Field>

                      {/* Assinatura do Cliente */}
                      <div className="mt-3">
                        <p className="text-xs font-medium text-gray-500 mb-2">
                          Assinatura do Cliente
                        </p>
                        <div className="space-y-3">
                          <div className="relative">
                            <button
                              type="button"
                              className="w-full h-[100px] border-2 border-dashed border-[#0085BD]/30 rounded-xl flex items-center justify-center bg-white cursor-pointer hover:bg-green-50 transition-all duration-200 relative group"
                              onClick={() => openSignatureModal("responsible_signature")}
                            >
                              {responsibleSignatureData ? (
                                <>
                                  <img
                                    src={responsibleSignatureData}
                                    alt="Nova Assinatura do Cliente"
                                    className="max-h-full max-w-full object-contain"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200 rounded-xl flex items-center justify-center">
                                    <span className="bg-[#0085BD] text-white px-3 py-1 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                      Clique para editar
                                    </span>
                                  </div>
                                </>
                              ) : report && report.responsible_signature ? (
                                <>
                                  <img
                                    className="max-h-full max-w-full object-contain"
                                    src={`https://app-luvilimp.s3.amazonaws.com/techVisitReportSignatureImages/${report.responsible_signature}`}
                                    alt="Assinatura do Cliente"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200 rounded-xl flex items-center justify-center">
                                    <span className="bg-[#0085BD] text-white px-3 py-1 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                      Clique para editar
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="text-center text-[#7FA5B2]">
                                  <svg className="mx-auto h-6 w-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  <p className="text-xs">Clique para assinar</p>
                                </div>
                              )}
                            </button>
                          </div>
                          {(responsibleSignatureData || (report && report.responsible_signature)) && (
                            <div className="flex gap-2">
                              <button
                                type="button"
                                onClick={() => openSignatureModal("responsible_signature")}
                                className="flex-1 px-2 py-2 bg-[#0085BD] text-white rounded-lg hover:bg-[#006a99] transition-all duration-200 text-xs font-semibold flex items-center justify-center gap-1"
                              >
                                <FiEdit2 size={14} /> Editar
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal de Assinatura */}
                {modalAddSignature && (
                  <ModalAddSignatureLocal
                    type={signatureType}
                    setModalAddSignature={setModalAddSignature}
                    setTechnicianSignature={() => undefined}
                    setResponsibleSignature={() => undefined}
                    onSaveSignature={handleSaveSignatureLocal}
                  />
                )}
              </div>

              {/* Botão de Salvar */}
              <div className="flex justify-end">
                <FormButton
                  title="Salvar Alterações"
                  type="submit"
                  variant="success"
                  icon="save"
                />
              </div>
            </Form>
          )}
        </Formik>

        {/* Seção de Comentários */}
        <div className="mt-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-800">Comentários</h2>
            {comments && comments.length > 0 && (
              <span className="bg-indigo-100 text-indigo-600 text-sm font-medium px-3 py-1 rounded-full">
                {comments.length}
              </span>
            )}
          </div>

          {/* Lista de Comentários */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-5 shadow-inner">
            {comments && comments.length > 0 ? (
              <div className="space-y-4">
                {comments.map(
                  ({
                    id: comment_id,
                    user: author_comment,
                    comment: user_comment,
                    created_at,
                  }: Comments) => (
                    <div
                      key={comment_id}
                      className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow duration-200 border border-gray-100"
                    >
                      <div className="flex items-start gap-3">
                        {/* Avatar do usuário */}
                        <div className="flex-shrink-0">
                          {author_comment.avatar_url ? (
                            <img
                              src={author_comment.avatar_url}
                              alt={author_comment.name}
                              className="w-10 h-10 rounded-full object-cover ring-2 ring-indigo-100"
                            />
                          ) : (
                            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white font-semibold text-sm">
                              {author_comment.name.charAt(0).toUpperCase()}
                            </div>
                          )}
                        </div>

                        {/* Conteúdo do comentário */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="font-semibold text-gray-800">
                              {author_comment.name}
                            </span>
                            <span className="text-xs text-gray-400 flex items-center gap-1">
                              <svg
                                className="w-3 h-3"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                              {moment(created_at).format(
                                "DD/MM/YYYY [às] HH:mm",
                              )}
                            </span>
                          </div>
                          <p className="mt-2 text-gray-600 leading-relaxed">
                            {user_comment}
                          </p>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mb-4">
                  <svg
                    className="w-8 h-8 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-500 mb-1">
                  Nenhum comentário ainda
                </h3>
                <p className="text-sm text-gray-400">
                  Seja o primeiro a comentar neste relatório!
                </p>
              </div>
            )}
          </div>

          {/* Campo para novo comentário */}
          <div className="mt-6 bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-3">
              {user.avatar_url ? (
                <img
                  src={user.avatar_url}
                  alt={user.name}
                  className="w-10 h-10 rounded-full object-cover ring-2 ring-indigo-100"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white font-semibold text-sm">
                  {user.name.charAt(0).toUpperCase()}
                </div>
              )}
              <span className="font-medium text-gray-700">
                Comentar como{" "}
                <span className="text-indigo-600">{user.name}</span>
              </span>
            </div>
            <textarea
              placeholder="Escreva seu comentário aqui..."
              name="comment"
              value={comment}
              onChange={e => setComment(e.target.value)}
              className="h-[100px] p-4 w-full rounded-xl text-gray-700 bg-gray-50 focus:bg-white focus:outline-none resize-none scrollbar-thumb-indigo-300 scrollbar-track-transparent scrollbar-thin focus:ring-2 focus:ring-indigo-200 border border-gray-200 transition-all duration-200 placeholder-gray-400"
            />
            <FormButton
              title="Enviar Comentário"
              onClick={() => sendComment()}
              variant="comment"
              icon="send"
              disabled={!comment.trim()}
            />
          </div>
        </div>

        {/* Modal de Preview de Imagem */}
        {imagePreview.show && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="relative max-w-4xl max-h-full">
              {/* Botão Fechar */}
              <button
                type="button"
                onClick={closeImagePreview}
                className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors z-10"
                aria-label="Fechar preview"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Imagem */}
              <button
                type="button"
                className="p-0 border-0 bg-transparent focus:outline-none"
                onClick={closeImagePreview}
                aria-label="Fechar preview da imagem"
              >
                <img
                  src={imagePreview.src}
                  alt={imagePreview.alt}
                  className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
                  style={{ cursor: 'zoom-out' }}
                />
              </button>

              {/* Overlay clicável para fechar */}
              <button
                type="button"
                className="absolute inset-0 -z-10 bg-transparent border-0 focus:outline-none"
                onClick={closeImagePreview}
                aria-label="Fechar preview"
                tabIndex={-1}
              />

              {/* Legenda */}
              {imagePreview.alt && (
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-center py-2 px-4 rounded-b-lg">
                  {imagePreview.alt}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
